/** Browser tab titles for /app (client-only; avoids stale "404" after visiting NotFoundPage). */
export function documentTitleForAppPath(pathname: string): string {
  const p = pathname.replace(/\/$/, '') || '/app';
  if (p === '/app' || p === '/app/dashboard') return 'Layerre | Dashboard';
  if (p.startsWith('/app/api-keys')) return 'Layerre | API Keys';
  if (p.startsWith('/app/billing')) return 'Layerre | Usage & Billing';
  if (p.startsWith('/app/integrations')) return 'Layerre | Integrations';
  if (p.startsWith('/app/create')) return 'Layerre | Create';
  if (p.startsWith('/app/profile')) return 'Layerre | Profile';
  return 'Layerre | Dashboard';
}
